import { Button, TableCell } from '@mui/material'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'

const ExpensesHeaderCell = ({
  cellName,
  width,
  textAlign,
  sortConfig,
  onExpensesTableHeadSort,
  paddingRight,
  paddingLeft,
}) => {
  const isSorted = sortConfig?.key === cellName
  const SortIcon =
    sortConfig?.direction === 'asc' ? ArrowDownwardIcon : ArrowUpwardIcon

  return (
    <TableCell
      style={{
        width,
        color: 'black',
        borderBottom: 'none',
        justifyContent: textAlign ? textAlign : 'left',
        textAlign: textAlign ? textAlign : 'left',
        paddingRight: paddingRight ? paddingRight : '0',
        paddingLeft: paddingLeft ? paddingLeft : '',
      }}
    >
      <Button
        style={{
          color: isSorted ? '#183a60' : 'black',
          fontWeight: isSorted ? 'bold' : 'normal',
          fontSize: '18px',
          padding: '0px',
        }}
        onClick={
          onExpensesTableHeadSort
            ? () => onExpensesTableHeadSort(cellName)
            : undefined
        }
        disabled={!onExpensesTableHeadSort} // If sorting function is not provided, disable the sorting button
      >
        {cellName}
        {isSorted && <SortIcon fontSize="small" />}
      </Button>
    </TableCell>
  )
}

export default ExpensesHeaderCell
